export default {
    id: "main-page-redesign-2026",
    articleType: "release",
    slug: "obnovlenie-glavnoy-stranitsy-i-razdel-novostey",
    date: "13 августа 2026",
    dateTime: "2026-08-13",
    modifiedTime: "2026-08-13",
    author: "Редакция «Светофор Логистика»",
    category: "Обновления платформы · 2026",
    contentType: "Обновление",
    title: "Обновили главную страницу и запустили раздел новостей",
    sidebarTitle: "Новая главная страница и раздел новостей",
    seoTitle:
        "Обновление сайта: новая главная и раздел новостей | «Светофор Логистика»",
    seoDescription:
        "«Светофор Логистика» обновила главную страницу сайта и запустила новый раздел с новостями, обновлениями и важными материалами о платформе.",
    image:
        "/img/news/obnovlenie-glavnoy-stranitsy-i-razdel-novostey/cover.webp",
    imageAlt:
        "Обновлённая главная страница и раздел новостей «Светофор Логистика»",
    featured: {
        badgeKey: "main.landing.news.items.mainPageRedesign2026.badge",
        metaKey: "main.landing.news.items.mainPageRedesign2026.meta",
        titleKey: "main.landing.news.items.mainPageRedesign2026.title",
        descriptionKey:
            "main.landing.news.items.mainPageRedesign2026.description",
        actionKey: "main.landing.news.items.mainPageRedesign2026.action",
    },
    content: {
        subtitle:
            "Публичная часть «Светофор Логистика» стала удобнее и информативнее",
        lead: [
            "Мы обновили главную страницу «Светофор Логистика». Новый дизайн помогает быстрее познакомиться с возможностями платформы, выбрать подходящий сценарий работы и перейти к нужному разделу.",
            "Одновременно с обновлением главной страницы мы запустили отдельный раздел с новостями платформы. Теперь важные материалы не будут теряться среди других разделов сайта.",
        ],
        sections: [
            {
                icon: "✨",
                title: "Что изменилось",
                itemHeadingLevel: 3,
                items: [
                    {
                        title: "Новая композиция главной страницы",
                        text: "Контент стал шире, основные разделы получили более понятную структуру, а важные действия теперь легче найти.",
                    },
                    {
                        title: "Обновлённая навигация",
                        text: "Переходы к возможностям платформы, тарифам, инструкциям и новостям собраны в единой системе навигации.",
                    },
                    {
                        title: "Единый визуальный стиль",
                        text: "Главная страница стала основой для постепенного обновления публичной части «Светофор Логистика».",
                    },
                    {
                        title: "Раздел с новостями",
                        text: "Материалы о развитии платформы, законодательных изменениях и новых возможностях теперь собраны в одном месте.",
                    },
                ],
            },
            {
                icon: "📰",
                title: "Новый раздел с новостями",
                paragraphs: [
                    "Раздел будет использоваться как единый информационный центр публичной части сайта. Здесь мы планируем публиковать:",
                ],
                list: [
                    "обновления платформы и её интерфейса;",
                    "новые функции и изменения существующих возможностей;",
                    "материалы для грузовладельцев, перевозчиков и экспедиторов;",
                    "важные отраслевые и законодательные изменения;",
                ],
            },
            {
                icon: "🚦",
                title: "Что будет дальше",
                paragraphs: [
                    "Обновление главной страницы — первый этап постепенного развития интерфейса «Светофор Логистика». Мы продолжим улучшать публичные разделы сайта, сохраняя привычную логику работы самой платформы.",
                    "Все новые материалы будут появляться в новостной ленте и в специальном блоке на главной странице.",
                ],
            },
        ],
        callout: {
            label: "Первый большой материал",
            title: "СОРМ и новые требования для экспедиторов в 2026 году",
            description:
                "Разбираем взаимодействие с ФСБ, хранение данных, обязанности экспедиторов и возможные штрафы.",
            action: {
                path: "/news/sorm-dlya-ekspeditorov-2026",
                label: "Прочитать материал",
            },
        },
    },
};
